import React from "react";
import ReactDOM from "react-dom";
import ModalLegendUploadEmployees from "../components/modalLegendUploadEmployees";
import generateUploadEmployeesSpreadsheetTemplate from "../../../services/generateUploadEmployeesSpreadsheetTemplate";

function renderUploadMultipleEmployeesModal(props) {
  ReactDOM.render(
    <ModalLegendUploadEmployees {...props} />,
    document.getElementById("modal-container")
  );
}

export function uploadMultipleEmployees(props) {
  generateUploadEmployeesSpreadsheetTemplate();
  renderUploadMultipleEmployeesModal(props);
}
